import React from 'react';
// settings
import { SETTINGS } from 'modules/emergencies/constants';
// components
import HeaderText from 'modules/emergencies/components/ui/texts/HeaderText';
import HeaderColumn from '../../../ui/columns/headerColumn';
import StartColumnsContainer from 'modules/emergencies/components/ui/containers/startColumnsContainer';
import EndColumnsContainer from 'modules/emergencies/components/ui/containers/endColumnsContainer';
import HeaderRow from 'modules/emergencies/components/ui/rows/headerRow';
import { useSelector } from 'react-redux';
import {
  constants,
  getSpecificClientConfig,
} from '../../../../../../redux/modules/client-config/selectors';

const columnWidths = SETTINGS.TICKETS_TABLE_COLUMN_SIZES_IN_PX;
const headerColumns = {
  startColumns: [
    {
      width: columnWidths.TICKET,
      text: 'TICKET',
    },
    {
      width: columnWidths.SHIPPER,
      text: 'SHIPPER',
    },
    {
      width: columnWidths.LOCATIONS,
      text: 'LOCATIONS',
    },
    {
      width: columnWidths.SERVICE,
      text: 'SERVICE',
      centerContent: true,
    },
    {
      width: columnWidths.CARRIER,
      text: 'CARRIER',
      centerContent: true,
    },
    {
      width: columnWidths.QUOTE,
      text: 'QUOTE',
      centerContent: true,
    },
    {
      width: columnWidths.REQUIREMENTS,
      text: 'NEEDS',
      centerContent: true,
    },
  ],
  endColumns: [
    {
      width: columnWidths.OWNER,
      text: 'OWNER / AGENT',
      centerContent: true,
    },
  ],
};

const TicketsListTableHeaderRow = () => {
  const actionsEnabled = useSelector((state) =>
    getSpecificClientConfig(state, constants.TICKET_LIST_ACTIONS_ENABLED)
  );

  return (
    <HeaderRow>
      <StartColumnsContainer>
        {headerColumns.startColumns.map((column, index) => (
          <HeaderColumn key={index} width={column.width} centerContent={!!column.centerContent}>
            <HeaderText>{column.text}</HeaderText>
          </HeaderColumn>
        ))}
      </StartColumnsContainer>
      <EndColumnsContainer>
        {headerColumns.endColumns.map((column, index) => (
          <HeaderColumn key={index} width={column.width} centerContent={!!column.centerContent}>
            <HeaderText>{column.text}</HeaderText>
          </HeaderColumn>
        ))}
        {actionsEnabled && (
          <HeaderColumn width={columnWidths.ACTIONS} centerContext={true}>
            <HeaderText></HeaderText>
          </HeaderColumn>
        )}
      </EndColumnsContainer>
    </HeaderRow>
  );
};

export default TicketsListTableHeaderRow;
